import { render, staticRenderFns } from "./CustomerDetailsModel.vue?vue&type=template&id=c4616aca"
import script from "./CustomerDetailsModel.vue?vue&type=script&lang=js"
export * from "./CustomerDetailsModel.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetailsModel.vue?vue&type=style&index=0&id=c4616aca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports